import { render } from "./GamePlay.vue?vue&type=template&id=935dc7b2"
import script from "./GamePlay.vue?vue&type=script&lang=js"
export * from "./GamePlay.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hutch/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__